export default "__VITE_PUBLIC_ASSET__844c2a4d__"